import React,{useState} from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
// import { SidebarLeft } from '../templates/';

import {
  SidebarProvider,
  SidebarInset,
} from "../components/ui/sidebar"

import {
  MobileNavigation,
  FavoritesIcon,
  UsersIcon,
  BookOpenWhite,
  ElementEqualIcon,
  HomeIcon,
  HelpIcon,
  CalendarWhite,
  CalendarIconFilled,
  HomeIconFilled,
  MoreIcon,
  MoreIconFilled,
  FavoritesIconFilled,
} from '../components';
import { AppSidebar } from '../templates/AppSidebar';


const mobileNavigationItems = [
  { id: 1, label: 'Home', href: '/', defaultIcon: HomeIcon, activeIcon: HomeIconFilled, active: true },
  { id: 2, label: 'Calendar', href: '/calendar', defaultIcon: CalendarWhite, activeIcon: CalendarIconFilled, active: false },
  { id: 3, label: 'Favorites', href: '/favorites', defaultIcon: FavoritesIcon, activeIcon: FavoritesIconFilled, active: false },
  { id: 4, label: 'More', defaultIcon: MoreIcon, activeIcon: MoreIconFilled, active: false},
];

const mobileNavMoreOptionItems = [
  { label: 'Culture & Customs', href: '/culture-and-customs', Icon: ElementEqualIcon },
  { label: 'Prayer & Rites', href: '/prayer-and-rites', Icon: BookOpenWhite },
  { label: 'Learn the Faith', href: '/learn-the-faith', Icon: UsersIcon },
  { label: 'Help', href: '/', Icon: HelpIcon },
];

function Layout() {
  const location = useLocation();
  const sidebarClass = `hidden md:block sticky top-0 w-full h-full md:max-w-[30%] ${location.pathname === '/single-day' ? 'lg:max-w-[30%]' : 'lg:max-w-[22%]'} xl:max-w-17`;
  const isMenuHidden = true;
  const [isModalOpen, setIsModalOpen] = useState(true);
  return (

    <div className={`App ${!isMenuHidden ? "hidden" : ""}`}>
      <section>
            <SidebarProvider className="w-full">
              <AppSidebar />
              <SidebarInset className="w-full xl:w-auto">
                <div className="flex flex-wrap h-full">
                  <Outlet/>
                </div>
              </SidebarInset>
            </SidebarProvider>
          {/* Mobile Navigation Start */}
          <MobileNavigation items={mobileNavigationItems} moreOption={mobileNavMoreOptionItems} />
      </section>
    </div>
  );
}

export default Layout;